import { Form, Input, Modal } from "antd";
import React, { useState } from "react";
import { ImageArrayUpload } from "../qmade/creator/AIModelManager";
import log from "cslog";
import { useGeneratePreset } from "../_actions/bot";

const { TextArea } = Input;


function PresetGenModal({ trigger }) {
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const [data, setData] = useState({})
    const mutationGen = useGeneratePreset((result) => {
        log.d(result, "result in PGM")
        setOpen(false)
    })

    log.d(data, "Data in PGM")

    const generatePreset = () => {
        log.d(data, "All data in GPD")
        mutationGen.mutate(data);
    }

    return (
        <>
            <span onClick={() => setOpen(true)}>{trigger}</span>
            <Modal
                title="Generate Preset with AI"
                open={open}
                onCancel={() => setOpen(false)}
                okText="Generate"
                cancelText="Cancel"
                onOk={() => {
                    generatePreset()
                }}
                confirmLoading={mutationGen.isLoading}
            >
                <Form form={form} layout="vertical" onFinish={generatePreset}>
                    <Form.Item label="Preset Name" name="name">
                        <Input value={data.name} onChange={(e) => setData({ ...data, name: e.target.value })} />
                    </Form.Item>
                    <Form.Item label="Preset Description" name="description">
                        <TextArea rows={6}
                            value={data.description}
                            onChange={(e) => setData({ ...data, description: e.target.value })}
                        />
                    </Form.Item>
                    <Form.Item
                        label="Person photos for training (minimum 3)"
                        name="reference_images"
                    >
                        <ImageArrayUpload
                            value={data.images}
                            onChange={(val) => {
                                setData({
                                    ...data,
                                    images: val,
                                    // reference_images: val.map((item) => ({
                                    //     directus_ai_model_id: "+",
                                    //     directus_files_id: { id: item.id },
                                    // })),
                                });
                            }}
                        />
                    </Form.Item>
                </Form>
            </Modal>
        </>
    );
}


export default PresetGenModal;